module.exports = __webpack_public_path__ + "img/环境2.26577ebb.png";